import stableSort from "stable";
import { IEntityFilter, IFilter } from "../../../../context/filters";
import { isFilterNotSortable } from "./isFilterNotSortable";

const sortFilters = (filterA: IFilter, filterB: IFilter) => filterA.order - filterB.order;

const sortFiltersFromEntity = ({ filters, ...rest }: IEntityFilter): IEntityFilter => {
  const validFilters = filters.filter(isFilterNotSortable) as IFilter[];
  const sortedFilters = stableSort(validFilters, sortFilters);
  return { filters: sortedFilters, ...rest };
};

const sortEntityFilters = (entityA: IEntityFilter, entityB: IEntityFilter) =>
  entityA.order - entityB.order;

export const getSortedFilters = (entityFilters: IEntityFilter[]) =>
  stableSort(entityFilters, sortEntityFilters).map(sortFiltersFromEntity);
